import { gql } from '@apollo/client'

export default gql`
  mutation addStudentToSection($code: String!) {
    addStudentToSection(code: $code) {
      name
    }
  }
`
